import { render, staticRenderFns } from "./form-upload.vue?vue&type=template&id=3b359a84&scoped=true&"
import script from "./form-upload.vue?vue&type=script&lang=js&"
export * from "./form-upload.vue?vue&type=script&lang=js&"
import style0 from "./form-upload.vue?vue&type=style&index=0&id=3b359a84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b359a84",
  null
  
)

export default component.exports